import {
    take,
    put,
    call,
    all,
    takeLatest,
    takeEvery,
} from 'redux-saga/effects';
import { pmsActions as actions, notificationActions } from '../actions';
import { pmsService } from '../services';

/*Create Kra Sagas */
function* handleCreateKraRequest() {
    const action = yield take(actions.createKraRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.createKra, dataParams);
        if (res.isError) {
            yield put(actions.createKraError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.createKraSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.createKraError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Kra Details Sagas*/
function* handleGetKraDetailsRequest() {
    const action = yield take(actions.getKraDetailsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.getKraDetails, dataParams);

        if (res.isError) {
            yield put(actions.getKraDetailsError(res));

        } else {
            yield put(actions.getKraDetailsSuccess(res));
        }

    } catch (error) {
        yield put(actions.getKraDetailsError());
    }
}

/* Get Kra Details Sagas*/
function* handleGetAllKraDetailsDataRequest() {
    const action = yield take(actions.getAllKraDetailsDataRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.getAllKraDetailsData, dataParams);

        if (res.isError) {
            yield put(actions.getAllKraDetailsDataError(res));

        } else {
            yield put(actions.getAllKraDetailsDataSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllKraDetailsDataError());
    }
}


/* Update Kra Detail Sagas */
function* handleUpdateKraDetailRequest() {
    const action = yield take(actions.updateKraDetailRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.updateKraDetail, dataParams);
        if (res.isError) {
            yield put(actions.updateKraDetailError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateKraDetailSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateKraDetailError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}
/* Delete Kra Detail Sagas*/
function* handleDeleteKraDetailRequest() {
    const action = yield take(actions.deleteKraDetailRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.deleteKraDetail, dataParams);
        if (res.isError) {
            yield put(actions.deleteKraDetailError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteKraDetailSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteKraDetailError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* create Kra Parameter Sagas */
function* handleCreateKraParameterRequest() {
    const action = yield take(actions.createKraParameterRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.createKraParameter, dataParams);
        if (res.isError) {
            yield put(actions.createKraParameterError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.createKraParameterSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.createKraError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Kra Parameters Sagas*/
function* handleGetKraParameterRequest() {
    const action = yield take(actions.getKraParameterRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.getKraParameter, dataParams);

        if (res.isError) {
            yield put(actions.getKraParameterError(res));

        } else {
            yield put(actions.getKraParameterSuccess(res));
        }

    } catch (error) {
        yield put(actions.getKraParameterError());
    }
}

/* Get All Kra Parameters Data Sagas*/
function* handleGetAllKraParameterDataRequest() {
    const action = yield take(actions.getAllKraParameterDataRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.getAllKraParameterData, dataParams);

        if (res.isError) {
            yield put(actions.getAllKraParameterDataError(res));

        } else {
            yield put(actions.getAllKraParameterDataSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllKraParameterDataError());
    }
}

/* Update Kra Parameter Sagas */
function* handleUpdateKraParameterRequest() {
    const action = yield take(actions.updateKraParameterRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.updateKraParameter, dataParams);
        if (res.isError) {
            yield put(actions.updateKraParameterError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateKraParameterSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateKraParameterError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}
/* Delete  Kra Parameter Sagas*/
function* handleDeleteKraParameterRequest() {
    const action = yield take(actions.deleteKraParameterRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.deleteKraParameter, dataParams);
        if (res.isError) {
            yield put(actions.deleteKraParameterError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteKraParameterSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteKraParameterError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* create KPi Details Sagas */
function* handleCreateKPiDetailsRequest() {
    const action = yield take(actions.createKPiDetailsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.createKPiDetails, dataParams);
        if (res.isError) {
            yield put(actions.createKPiDetailsError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.createKPiDetailsSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.createKPiDetailsError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Kpi Details Sagas*/
function* handleGetKpiDetailsRequest() {
    const action = yield take(actions.getKpiDetailsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.getKpiDetails, dataParams);

        if (res.isError) {
            yield put(actions.getKpiDetailsError(res));

        } else {
            yield put(actions.getKpiDetailsSuccess(res));
        }

    } catch (error) {
        yield put(actions.getKpiDetailsError());
    }
}

/* Get Kpi Details Sagas*/
function* handleGetAllKpiDetailsDataRequest() {
    const action = yield take(actions.getAllKpiDetailsDataRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.getAllKpiDetailsData, dataParams);

        if (res.isError) {
            yield put(actions.getAllKpiDetailsDataError(res));

        } else {
            yield put(actions.getAllKpiDetailsDataSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllKpiDetailsDataError());
    }
}

/* Update Kpi Detail Sagas */
function* handleUpdateKpiDetailRequest() {
    const action = yield take(actions.updateKpiDetailRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.updateKpiDetail, dataParams);
        if (res.isError) {
            yield put(actions.updateKpiDetailError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateKpiDetailSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateKpiDetailError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}
/* Delete  Kpi Detail Sagas*/
function* handleDeleteKpiDetailRequest() {
    const action = yield take(actions.deleteKpiDetailRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.deleteKpiDetail, dataParams);
        if (res.isError) {
            yield put(actions.deleteKpiDetailError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteKpiDetailSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteKpiDetailError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* create Kra Rating Type For Department Sagas */
function* handleCreateKraRatingTypeForDepartmentRequest() {
    const action = yield take(actions.createKraRatingTypeForDepartmentRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.createKraRatingTypeForDepartment, dataParams);
        if (res.isError) {
            yield put(actions.createKraRatingTypeForDepartmentError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.createKraRatingTypeForDepartmentSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.createKraRatingTypeForDepartmentError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Kpi Details Sagas*/
function* handleGetKraRatingTypeForDepartmentRequest() {
    const action = yield take(actions.getKraRatingTypeForDepartmentRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.getKraRatingTypeForDepartment, dataParams);

        if (res.isError) {
            yield put(actions.getKraRatingTypeForDepartmentError(res));

        } else {
            yield put(actions.getKraRatingTypeForDepartmentSuccess(res));
        }

    } catch (error) {
        yield put(actions.getKraRatingTypeForDepartmentError());
    }
}

/* Get Kpi Details Sagas*/
function* handleGetAllKraRatingTypeForDepartmentRequest() {
    const action = yield take(actions.getAllKraRatingTypeForDepartmentRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.getAllKraRatingTypeForDepartment, dataParams);

        if (res.isError) {
            yield put(actions.getAllKraRatingTypeForDepartmentError(res));

        } else {
            yield put(actions.getAllKraRatingTypeForDepartmentSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllKraRatingTypeForDepartmentError());
    }
}

/* update Kra Rating Type Department Sagas */
function* handleUpdateKraRatingTypeDepartmentRequest() {
    const action = yield take(actions.updateKraRatingTypeDepartmentRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.updateKraRatingTypeDepartment, dataParams);
        if (res.isError) {
            yield put(actions.updateKraRatingTypeDepartmentError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateKraRatingTypeDepartmentSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateKraRatingTypeDepartmentError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}
/* Delete  Kpi Detail Sagas*/
function* handleDeleteKraRatingTypeForDepartmentRequest() {
    const action = yield take(actions.deleteKraRatingTypeForDepartmentRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.deleteKraRatingTypeForDepartment, dataParams);
        if (res.isError) {
            yield put(actions.deleteKraRatingTypeForDepartmentError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteKraRatingTypeForDepartmentSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteKraRatingTypeForDepartmentError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* create Self Rating permission Sagas */
function* handleCreateSelfRatingPermissionRequest() {
    const action = yield take(actions.createSelfRatingPermissionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.createSelfRatingPermission, dataParams);
        if (res.isError) {
            yield put(actions.createSelfRatingPermissionError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.createSelfRatingPermissionSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.createSelfRatingPermissionError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Self Rating permission Sagas*/
function* handleGetSelfRatingPermissionRequest() {
    const action = yield take(actions.getSelfRatingPermissionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.getSelfRatingPermission, dataParams);

        if (res.isError) {
            yield put(actions.getSelfRatingPermissionError(res));

        } else {
            yield put(actions.getSelfRatingPermissionSuccess(res));
        }

    } catch (error) {
        yield put(actions.getSelfRatingPermissionError());
    }
}

/* Get All Self Rating permission Sagas*/
function* handleGetAllSelfRatingPermissionRequest() {
    const action = yield take(actions.getAllSelfRatingPermissionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.getAllSelfRatingPermission, dataParams);

        if (res.isError) {
            yield put(actions.getAllSelfRatingPermissionError(res));

        } else {
            yield put(actions.getAllSelfRatingPermissionSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllSelfRatingPermissionError());
    }
}

/* update Self Rating permission Sagas */
function* handleUpdateSelfRatingPermissionRequest() {
    const action = yield take(actions.updateSelfRatingPermissionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.updateSelfRatingPermission, dataParams);
        if (res.isError) {
            yield put(actions.updateSelfRatingPermissionError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateSelfRatingPermissionSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateSelfRatingPermissionError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}
/* Delete Self Rating permission Sagas*/
function* handleDeleteSelfRatingPermissionRequest() {
    const action = yield take(actions.deleteSelfRatingPermissionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.deleteSelfRatingPermission, dataParams);
        if (res.isError) {
            yield put(actions.deleteSelfRatingPermissionError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteSelfRatingPermissionSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteSelfRatingPermissionError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Assign Kra Sagas */
function* handleAssignKraRequest() {
    const action = yield take(actions.assignKraRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.AssignKra, dataParams);
        if (res.isError) {
            yield put(actions.assignKraError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.assignKraSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.assignKraError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Assign Kra Sagas*/
function* handleGetAssignKraRequest() {
    const action = yield take(actions.getAssignKraRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.getAssignKra, dataParams);

        if (res.isError) {
            yield put(actions.getAssignKraError(res));

        } else {
            yield put(actions.getAssignKraSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAssignKraError());
    }
}

/* Get All Assign Kra Sagas*/
function* handleGetAllAssignKraRequest() {
    const action = yield take(actions.getAllAssignKraRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.getAllAssignKra, dataParams);

        if (res.isError) {
            yield put(actions.getAllAssignKraError(res));

        } else {
            yield put(actions.getAllAssignKraSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllAssignKraError());
    }
}

/* update Assign Kra Sagas */
function* handleUpdateAssignKraRequest() {
    const action = yield take(actions.updateAssignKraRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.updateAssignKra, dataParams);
        if (res.isError) {
            yield put(actions.updateAssignKraError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateAssignKraSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateAssignKraError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}
/* Delete  Assign Kra Sagas*/
function* handleDeleteAssignKraRequest() {
    const action = yield take(actions.deleteAssignKraRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.deleteAssignKra, dataParams);
        if (res.isError) {
            yield put(actions.deleteAssignKraError  (res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteAssignKraSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteAssignKraError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* get Employee By Kra Sagas*/
function* handleGetEmployeeByKraRequest() {
    const action = yield take(actions.getEmployeeByKraRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.getEmployeeByKra, dataParams);
        if (res.isError) {
            yield put(actions.getEmployeeByKraError  (res));
        } else {
            yield put(actions.getEmployeeByKraSuccess(res));
        }
    } catch (error) {
        yield put(actions.getEmployeeByKraError());
    }
}


function* handleGiveRatingRequest() {
    const action = yield take(actions.giveRatingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.giveRating, dataParams);
        if (res.isError) {
            yield put(actions.giveRatingError  (res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.giveRatingSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.giveRatingError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

function* handleGetGivenRatingRequest() {
    const action = yield take(actions.getGivenRatingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.getGivenRating, dataParams);
        if (res.isError) {
            yield put(actions.getGivenRatingError  (res));
        } else {
            yield put(actions.getGivenRatingSuccess(res));
        }
    } catch (error) {
        yield put(actions.getGivenRatingError());
    }
}

/*Update Ration Duration Sagas*/
function* handleUpdateRatingDurationRequest() {
    const action = yield take(actions.updateRatingDurationRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.updateEmployeeRatingDuration, dataParams);
        if (res.isError) {
            yield put(actions.updateRatingDurationError  (res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateRatingDurationSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateRatingDurationError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}


/*Update Ration Duration Sagas*/
function* handleGetKraDetailsByEmployeeRequest() {
    const action = yield take(actions.getKraDetailsByEmployeeRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.getKraDetailsByEmployee, dataParams);
        if (res.isError) {
            yield put(actions.getKraDetailsByEmployeeError  (res));
 
        } else {
            yield put(actions.getKraDetailsByEmployeeSuccess(res));
     
        }
    } catch (error) {
        yield put(actions.getKraDetailsByEmployeeError());
        
    }
}

/* Get Rating Wise Employee Sagas*/
function* handleGetRatingWiseEmployeeRequest() {
    const action = yield take(actions.getRatingWiseEmployeeRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.getRatingWiseEmployee, dataParams);
        if (res.isError) {
            yield put(actions.getRatingWiseEmployeeError  (res));
 
        } else {
            yield put(actions.getRatingWiseEmployeeSuccess(res));
     
        }
    } catch (error) {
        yield put(actions.getRatingWiseEmployeeError());
        
    }
}

/* Get Average Rating Sagas*/
function* handleGetAverageRatingRequest() {
    const action = yield take(actions.getAverageRatingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(pmsService.getAverageRating, dataParams);
        if (res.isError) {
            yield put(actions.getAverageRatingError  (res));
 
        } else {
            yield put(actions.getAverageRatingSuccess(res));
     
        }
    } catch (error) {
        yield put(actions.getAverageRatingError());
        
    }
}



/* -----------Watchers------------- */
function* handleCreateKraWatcher() {
    yield takeEvery(
        actions.createKraRequest,
        handleCreateKraRequest,
    );
}

function* handleGetKraDetailsWatcher() {
    yield takeEvery(
        actions.getKraDetailsRequest,
        handleGetKraDetailsRequest,
    );
}

function* handleGetAllKraDetailsDataWatcher() {
    yield takeEvery(
        actions.getAllKraDetailsDataRequest,
        handleGetAllKraDetailsDataRequest,
    );
}


function* handleUpdateKraDetailWatcher() {
    yield takeEvery(
        actions.updateKraDetailRequest,
        handleUpdateKraDetailRequest,
    );
}

function* handleDeleteKraDetailWatcher() {
    yield takeEvery(
        actions.deleteKraDetailRequest,
        handleDeleteKraDetailRequest,
    );
}

function* handleCreateKraParameterWatcher() {
    yield takeEvery(
        actions.createKraParameterRequest,
        handleCreateKraParameterRequest,
    );
}

function* handleGetKraParameterWatcher() {
    yield takeEvery(
        actions.getKraParameterRequest,
        handleGetKraParameterRequest,
    );
}

function* handleGetAllKraParameterDataWatcher() {
    yield takeEvery(
        actions.getAllKraParameterDataRequest,
        handleGetAllKraParameterDataRequest,
    );
}

function* handleUpdateKraParameterWatcher() {
    yield takeEvery(
        actions.updateKraParameterRequest,
        handleUpdateKraParameterRequest,
    );
}

function* handleDeleteKraParameterWatcher() {
    yield takeEvery(
        actions.deleteKraParameterRequest,
        handleDeleteKraParameterRequest,
    );
}

function* handleCreateKPiDetailsWatcher() {
    yield takeEvery(
        actions.createKPiDetailsRequest,
        handleCreateKPiDetailsRequest,
    );
}

function* handleGetKpiDetailsWatcher() {
    yield takeEvery(
        actions.getKpiDetailsRequest,
        handleGetKpiDetailsRequest,
    );
}

function* handleGetAllKpiDetailsDataWatcher() {
    yield takeEvery(
        actions.getAllKpiDetailsDataRequest,
        handleGetAllKpiDetailsDataRequest,
    );
}

function* handleUpdateKpiDetailWatcher() {
    yield takeEvery(
        actions.updateKpiDetailRequest,
        handleUpdateKpiDetailRequest,
    );
}

function* handleDeleteKpiDetailWatcher() {
    yield takeEvery(
        actions.deleteKpiDetailRequest,
        handleDeleteKpiDetailRequest,
    );
}

function* handleCreateKraRatingTypeForDepartmentWatcher() {
    yield takeEvery(
        actions.createKraRatingTypeForDepartmentRequest,
        handleCreateKraRatingTypeForDepartmentRequest,
    );
}

function* handleGetKraRatingTypeForDepartmentWatcher() {
    yield takeEvery(
        actions.getKraRatingTypeForDepartmentRequest,
        handleGetKraRatingTypeForDepartmentRequest,
    );
}

function* handleGetAllKraRatingTypeForDepartmentWatcher() {
    yield takeEvery(
        actions.getAllKraRatingTypeForDepartmentRequest,
        handleGetAllKraRatingTypeForDepartmentRequest,
    );
}

function* handleUpdateKraRatingTypeDepartmentWatcher() {
    yield takeEvery(
        actions.updateKraRatingTypeDepartmentRequest,
        handleUpdateKraRatingTypeDepartmentRequest,
    );
}

function* handleDeleteKraRatingTypeForDepartmentWatcher() {
    yield takeEvery(
        actions.deleteKraRatingTypeForDepartmentRequest,
        handleDeleteKraRatingTypeForDepartmentRequest,
    );
}

function* handleCreateSelfRatingPermissionWatcher() {
    yield takeEvery(
        actions.createSelfRatingPermissionRequest,
        handleCreateSelfRatingPermissionRequest,
    );
}
function* handleGetSelfRatingPermissionWatcher() {
    yield takeEvery(
        actions.getSelfRatingPermissionRequest,
        handleGetSelfRatingPermissionRequest,
    );
}
function* handleGetAllSelfRatingPermissionWatcher() {
    yield takeEvery(
        actions.getAllSelfRatingPermissionRequest,
        handleGetAllSelfRatingPermissionRequest,
    );
}
function* handleUpdateSelfRatingPermissionWatcher() {
    yield takeEvery(
        actions.updateSelfRatingPermissionRequest,
        handleUpdateSelfRatingPermissionRequest,
    );
}
function* handleDeleteSelfRatingPermissionWatcher() {
    yield takeEvery(
        actions.deleteSelfRatingPermissionRequest,
        handleDeleteSelfRatingPermissionRequest,
    );
}
function* handleAssignKraWatcher() {
    yield takeEvery(
        actions.assignKraRequest,
        handleAssignKraRequest,
    );
}
function* handleGetAssignKraWatcher() {
    yield takeEvery(
        actions.getAssignKraRequest,
        handleGetAssignKraRequest,
    );
}
function* handleGetAllAssignKraWatcher() {
    yield takeEvery(
        actions.getAllAssignKraRequest,
        handleGetAllAssignKraRequest,
    );
}
function* handleUpdateAssignKraWatcher() {
    yield takeEvery(
        actions.updateAssignKraRequest,
        handleUpdateAssignKraRequest,
    );
}
function* handleDeleteAssignKraWatcher() {
    yield takeEvery(
        actions.deleteAssignKraRequest,
        handleDeleteAssignKraRequest,
    );
}

function* handleGetEmployeeByKraWatcher() {
    yield takeEvery(
        actions.getEmployeeByKraRequest,
        handleGetEmployeeByKraRequest,
    );
}

function* handleGiveRatingWatcher() {
    yield takeEvery(
        actions.giveRatingRequest,
        handleGiveRatingRequest,
    );
}

function* handleGetGivenRatingWatcher() {
    yield takeEvery(
        actions.getGivenRatingRequest,
        handleGetGivenRatingRequest,
    );
}

function* handleUpdataRatingDurationWatcher() {
    yield takeEvery(
        actions.updateRatingDurationRequest,
        handleUpdateRatingDurationRequest,
    );
}

function* handleGetKraDetailsByEmployeeWatcher() {
    yield takeEvery(
        actions.getKraDetailsByEmployeeRequest,
        handleGetKraDetailsByEmployeeRequest,
    );
}

function* handleGetRatingWiseEmployeeWatcher() {
    yield takeEvery(
        actions.getRatingWiseEmployeeRequest,
        handleGetRatingWiseEmployeeRequest,
    );
}


function* handleGetAverageRatingWatcher() {
    yield takeEvery(
        actions.getAverageRatingRequest,
        handleGetAverageRatingRequest,
    );
}

function* rootPMSSaga() {
    yield all([
        handleCreateKraRequest(),
        handleCreateKraWatcher(),

        handleGetKraDetailsRequest(),
        handleGetKraDetailsWatcher(),

        handleGetAllKraDetailsDataRequest(),
        handleGetAllKraDetailsDataWatcher(),

        handleUpdateKraDetailRequest(),
        handleUpdateKraDetailWatcher(),

        handleDeleteKraDetailRequest(),
        handleDeleteKraDetailWatcher(),

        handleCreateKraParameterRequest(),
        handleCreateKraParameterWatcher(),

        handleGetKraParameterRequest(),
        handleGetKraParameterWatcher(),
        
        handleGetAllKraParameterDataRequest(),
        handleGetAllKraParameterDataWatcher(),

        handleUpdateKraParameterRequest(),
        handleUpdateKraParameterWatcher(),

        handleDeleteKraParameterRequest(),
        handleDeleteKraParameterWatcher(),

        handleCreateKPiDetailsRequest(),
        handleCreateKPiDetailsWatcher(),

        handleGetKpiDetailsRequest(),
        handleGetKpiDetailsWatcher(),

        handleGetAllKpiDetailsDataRequest(),
        handleGetAllKpiDetailsDataWatcher(),

        handleUpdateKpiDetailRequest(),
        handleUpdateKpiDetailWatcher(),

        handleDeleteKpiDetailRequest(),
        handleDeleteKpiDetailWatcher(),

        handleCreateKraRatingTypeForDepartmentRequest(),
        handleCreateKraRatingTypeForDepartmentWatcher(),

        handleGetKraRatingTypeForDepartmentRequest(),
        handleGetKraRatingTypeForDepartmentWatcher(),

        handleGetAllKraRatingTypeForDepartmentRequest(),
        handleGetAllKraRatingTypeForDepartmentWatcher(),

        handleUpdateKraRatingTypeDepartmentRequest(),
        handleUpdateKraRatingTypeDepartmentWatcher(),

        handleDeleteKraRatingTypeForDepartmentRequest(),
        handleDeleteKraRatingTypeForDepartmentWatcher(),

        handleCreateSelfRatingPermissionRequest(),
        handleCreateSelfRatingPermissionWatcher(),

        handleGetSelfRatingPermissionRequest(),
        handleGetSelfRatingPermissionWatcher(),

        handleGetAllSelfRatingPermissionRequest(),
        handleGetAllSelfRatingPermissionWatcher(),

        handleUpdateSelfRatingPermissionRequest(),
        handleUpdateSelfRatingPermissionWatcher(),

        handleDeleteSelfRatingPermissionRequest(),
        handleDeleteSelfRatingPermissionWatcher(),

        handleAssignKraRequest(),
        handleAssignKraWatcher(),

        handleGetAssignKraRequest(),
        handleGetAssignKraWatcher(),

        handleGetAllAssignKraRequest(),
        handleGetAllAssignKraWatcher(),

        handleUpdateAssignKraRequest(),
        handleUpdateAssignKraWatcher(),

        handleDeleteAssignKraRequest(),
        handleDeleteAssignKraWatcher(),

        handleGetEmployeeByKraRequest(),
        handleGetEmployeeByKraWatcher(),

        handleUpdateRatingDurationRequest(),
        handleUpdataRatingDurationWatcher(),
        
        handleGetKraDetailsByEmployeeRequest(),
        handleGetKraDetailsByEmployeeWatcher(),
   
        handleGiveRatingRequest(),
        handleGiveRatingWatcher(),

        handleGetGivenRatingRequest(),
        handleGetGivenRatingWatcher(),

        handleGetRatingWiseEmployeeRequest(),
        handleGetRatingWiseEmployeeWatcher(),

        handleGetAverageRatingRequest(),
        handleGetAverageRatingWatcher(),
    ]);
}

export default rootPMSSaga;
